import styled from "styled-components";
import { Modal } from "antd";

export const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 0px;
    border-bottom: 0px solid #b6bdbd;
    @media only screen and (max-width: 991px) {
      padding: 0px;
    }
  }
  .ant-modal-title {
    @media only screen and (max-width: 576px) {
      padding: 0px 50px;
    }
  }
  .ant-modal {
    height: 361px;
  }
  .ant-modal-footer {
    border-top: 0px solid #b6bdbd;
    padding: 30px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    div {
      margin-top: 20px;
    }
    @media only screen and (max-width: 991px) {
      padding-top: 0;
      margin-top: auto;
    }
  }
  .ant-modal-body {
    padding: 12px 0px 0px 0px;
    @media only screen and (max-width: 991px) {
      padding: 0px;
    }
    .ant-table-wrapper {
      border-top: 1px solid #b6bdbd;
    }
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-content {
    border-radius: 0px;
    padding: 30px 
    @media only screen and (max-width: 576px) {
      padding: 30px 20px;
    }
    @media only screen and (max-width: 991px) {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  @media only screen and (max-width: 991px) {
    width: 98% !important;
    height: 430px;
    top: 10px;
    padding: 0;
    max-width: calc(100vw - 44px) !important;
    margin: 0px 22px !important;
    top: 18% !important;
  }
  @media only screen and (min-device-width : 766px) and (max-device-width : 800px) {
    top: 18% !important;
    height: 355px;
  }
  @media only screen and (max-width: 576px) {
    top: 18% !important;
    height: 430px
  }
  @media only screen and (min-device-width : 319px) and (max-device-width : 340px) {
    top: 7% !important;
    height: 503px;
  }
`;

export const ModalHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.oneP17};
  letter-spacing: ${props => props.theme.letterSpacing.normal}
  color: #022737;
  text-align: center;
  padding-bottom: 15px;
  @media only screen and (max-width: 991px) {
    line-height: 36px;
  }
`;

export const ExpirePara = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  text-align: center;
  @media only screen and (max-width: 576px) {
    padding: 0px 20px;
  }
`;

export const SecondCount = styled.p`
  font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
  font-size: 36px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${props => props.theme.colors.info};
  padding: 17px 0 17px 0;
  margin: 0px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
`;

export const Ahref = styled.a`
  padding-top: 10px;
  font-size: ${props => props.theme.fontSize.primary};
  text-decoration: underline;
  line-height: 24px;
  color: ${props => props.theme.fontColors.primary};
  &:hover {
    text-decoration: underline;
  }
`;

export const Button = styled.button`
  width: 292px;
  height: 50px;
  color: ${props => props.theme.colors.white};
  background-color: ${props=> props.theme.fontColors.primary};
  border: none;
  font-size: 18px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  letter-spacing: 1.13px;
  line-height: 30px;
  font-style: normal;
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;